import { render, staticRenderFns } from "./card_list.vue?vue&type=template&id=3132d3c0&scoped=true&"
import script from "./card_list.vue?vue&type=script&lang=js&"
export * from "./card_list.vue?vue&type=script&lang=js&"
import style0 from "./card_list.vue?vue&type=style&index=0&id=3132d3c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3132d3c0",
  null
  
)

export default component.exports